import { useQueryParams } from "@certn/api";
import { GhostButton } from "@certn/cascadia-react";
import React from "react";
import { Trans } from "react-i18next";

export function ClearFilters() {
  const { params, clearParams } = useQueryParams();

  const excludeParamKeys = ["page_size", "page"];
  if (
    Object.keys(params).filter((key) => !excludeParamKeys.includes(key))
      .length === 0
  ) {
    return null;
  }

  return (
    <GhostButton size="small" testID="clear-filters" onPress={clearParams}>
      <Trans>Clear filters</Trans>
    </GhostButton>
  );
}
